module.exports = __webpack_public_path__ + "img/slovakia.853919fd.svg";